import { db, type ProposalBundleRecord } from './codexDB';

export async function saveProposalBundle(record: ProposalBundleRecord): Promise<string> {
  await db.proposalBundles.put(record);
  return record.id;
}

export async function getProposalBundle(id: string): Promise<ProposalBundleRecord | undefined> {
  return db.proposalBundles.get(id);
}

/** 승인 큐 — 최신순. status 주면 필터(기본: 전부). */
export async function listProposalBundles(
  projectId: string,
  status?: ProposalBundleRecord['status'],
): Promise<ProposalBundleRecord[]> {
  const rows = await db.proposalBundles.where('projectId').equals(projectId).toArray();
  return rows.filter((r) => !status || r.status === status).sort((a, b) => b.createdAt - a.createdAt);
}

/** 작가 결정 기록 — 유일한 커밋 경로의 감사 흔적(approvalId·적용 노트). */
export async function decideProposalBundle(
  id: string,
  status: 'accepted' | 'rejected',
  opts: { approvalId?: string; appliedNotes?: string[] } = {},
): Promise<void> {
  await db.proposalBundles.update(id, {
    status,
    decidedAt: Date.now(),
    ...(opts.approvalId ? { approvalId: opts.approvalId } : {}),
    ...(opts.appliedNotes ? { appliedNotes: opts.appliedNotes } : {}),
  });
}
